import Fetch from "./index";

const realtimeRoute = (sessionId) =>
  `/generative-dialog-manager-proxy/${sessionId}/realtime/calls`;

export const createRealtimeCall = (sessionId, offer) =>
  Fetch(realtimeRoute(sessionId), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(offer),
  });

export const resumeRealtimeCall = (sessionId, callId, ticket, offer) =>
  Fetch(`${realtimeRoute(sessionId)}/${callId}/resume`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Realtime-Ticket": ticket,
    },
    body: JSON.stringify(offer),
  });

export const closeRealtimeCall = (sessionId, callId, ticket) =>
  Fetch(`${realtimeRoute(sessionId)}/${callId}`, {
    method: "DELETE",
    headers: { "X-Realtime-Ticket": ticket },
  });
